import useDebounce from '@hooks/useDebounce'
import SearchIcon from '@mui/icons-material/SearchOutlined'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import type { ChangeEvent, SetStateAction } from 'react'
import { useIntl } from 'react-intl'

import messages from './messages'
import type { ColumnCategory } from './useColumns'

interface ColumnPickerSearchProps {
  currentCategory: ColumnCategory
  setQuery: (value: SetStateAction<string>) => void
  query: string
}

export const ColumnPickerSearch = ({
  currentCategory,
  setQuery,
  query,
}: ColumnPickerSearchProps) => {
  const intl = useIntl()
  const debounceSearchChange = useDebounce((value: string) => currentCategory.onSearch(value), 500)

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value ?? ''

    setQuery(value)
    debounceSearchChange(value)
  }

  return (
    <TextField
      size="small"
      fullWidth
      placeholder={intl.formatMessage(messages.searchForColumns)}
      value={query}
      onChange={handleSearchChange}
      data-test-id="search-columns"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
    />
  )
}
